var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 d-flex align-items-center"},[_c('b-button',{attrs:{"id":"notifications","pill":"","size":"sm"},on:{"click":_vm.toggle}},[_c('b-icon',{attrs:{"icon":"bell-fill"}}),_vm._v(" "),(_vm.newNotif >= 1)?_c('span',[_vm._v(_vm._s(_vm.newNotif)+" "+_vm._s(_vm.$tc('generic.notifications', _vm.newNotif)))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }